<template>
  <ConfirmModal :title="$t('tools.share-the-diagnostic')" :hide-cancel="true" :hide-confirm="true">
    <template #body>
      <p class="subtitle has-text-black has-text-centered is-full-width is-size-5">
        {{ $t('tools.send-a-link-through-email') }}
      </p>
      <ValidationObserver v-slot="{ invalid }">
        <div class="is-flex-centered">
          <FormInput
            v-model="email"
            :rules="{ required: true, email: true }"
            :show-float-label="false"
            :placeholder="$t('tools.email')"
            class="column is-6 p-b-0"
            :data-e2e="DiagnosticToolCypressAttribute.inputs.EMAIL"
          />
          <ButtonView
            :disabled="invalid"
            icon-pack="cls"
            icon-left="cls-email-unread"
            class="m-b-15"
            :outlined="false"
            :loading="isLoading"
            type="is-primary is-light"
            @click="onSend"
            :data-e2e="DiagnosticToolCypressAttribute.buttons.SEND_EMAIL"
          >
            {{ $t('tools.send') }}
          </ButtonView>
        </div>
        <div class="is-flex-centered">
          <div class="has-text-weight-semibold m-r-20 is-uppercase">{{ $t('tools.or') }}</div>
          <DiagnosticToolCopyLinkButton :form-id="formId" />
        </div>
      </ValidationObserver>
    </template>
  </ConfirmModal>
</template>

<script>
import { DiagnosticToolSharedEventTracking } from '@/modules/typeform/models/segmentevents/DiagnosticToolSharedEventTracking';
import ValidationObserver from '/@/modules/core/form/components/ValidationObserver.vue';
import { ModalMixin } from '@/modules/core/ui/mixins/ModalMixin';
import { DiagnosticToolCypressAttribute } from '@/modules/typeform/constants/DiagnosticToolCypressAttribute';
import ToastService from '@/modules/core/ui/services/ToastService';
import DiagnosticToolSendShareableLinkService from '@/modules/typeform/services/DiagnosticToolSendShareableLinkService';
import FormInput from '@/modules/core/form/components/FormInput.vue';
import ConfirmModal from '@/modules/core/ui/components/ConfirmModal.vue';
import DiagnosticToolCopyLinkButton from '@/modules/typeform/components/presentational/DiagnosticToolCopyLinkButton.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DiagnosticToolShareFormModal',
  mixins: [ModalMixin],
  components: {
    ButtonView,
    DiagnosticToolCopyLinkButton,
    ValidationObserver,
    FormInput,
    ConfirmModal
  },
  props: {
    formId: {
      type: String,
      required: true
    }
  },
  static: {
    DiagnosticToolCypressAttribute
  },
  data() {
    return {
      email: null,
      isLoading: false
    };
  },
  methods: {
    async onSend() {
      this.isLoading = true;
      try {
        await DiagnosticToolSendShareableLinkService.send(this.formId, this.email);
        ToastService.show(this.$t('guidancestep.email-sent-successfully'));
        this.close();
        DiagnosticToolSharedEventTracking.dispatch(this.formId);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
